<script lang="ts">
    import { REWARDS_VIP_TIERS_CONDITION_TYPES } from "@apps/rewards/modules/VipTiers/types";

    //Props
    export let tierCondition: REWARDS_VIP_TIERS_CONDITION_TYPES;
</script>

{#if tierCondition === REWARDS_VIP_TIERS_CONDITION_TYPES.points}
    <slot name="points-goal" />
{/if}

{#if tierCondition === REWARDS_VIP_TIERS_CONDITION_TYPES.purchasesMade}
    <slot name="purchases-goal" />
{/if}

{#if tierCondition === REWARDS_VIP_TIERS_CONDITION_TYPES.spentAmount}
    <slot name="spent-amount-goal" />
{/if}

{#if tierCondition === REWARDS_VIP_TIERS_CONDITION_TYPES.completedReferrals}
    <slot name="referrals-goal" />
{/if}
